module.exports = __webpack_public_path__ + "img/tg.5d9b5630.png";